// extracted by mini-css-extract-plugin
export default {"wrapper":"Grad_wrapper__avN4c","label":"Grad_label__EXhjv","list":"Grad_list__uknkt","item":"Grad_item__wOi7N","active":"Grad_active__p548C"};